// extracted by mini-css-extract-plugin
export default {"BackdropPopupContainer":"Popup_BackdropPopupContainer__DLtvM","BackdropPopup":"Popup_BackdropPopup__8RGSb","Close":"Popup_Close__O8cK1"};